import { render, staticRenderFns } from "./LoaderModal.vue?vue&type=template&id=1c3c949a&scoped=true&"
import script from "./LoaderModal.vue?vue&type=script&lang=js&"
export * from "./LoaderModal.vue?vue&type=script&lang=js&"
import style0 from "./LoaderModal.vue?vue&type=style&index=0&id=1c3c949a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c949a",
  null
  
)

export default component.exports